import { render, staticRenderFns } from "./MonitoringView.vue?vue&type=template&id=56aefa20&scoped=true"
import script from "./MonitoringView.vue?vue&type=script&lang=js"
export * from "./MonitoringView.vue?vue&type=script&lang=js"
import style0 from "./MonitoringView.vue?vue&type=style&index=0&id=56aefa20&prod&lang=css"
import style1 from "./MonitoringView.vue?vue&type=style&index=1&id=56aefa20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aefa20",
  null
  
)

export default component.exports